export enum Unit {
    METRIC = "METRIC",
    EMPIRICAL = "EMPIRICAL"
}